import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/supporter/$supporterId/financial-reports/invoices")({
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
  }),
  beforeLoad: () => ({
    breadcrumb: "Billing",
  }),
  component: lazyRouteComponent(() => import("./+Billing")),
  head: () => ({ meta: seo({ title: "Billing" }) }),
});
